import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { getApi } from "../api";

export default () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ deviceId, payload }: {
            deviceId: number;
            payload: Record<string, unknown>;
        }) => {
            const { api, baseURL } = getApi();
            return api
                .put(`/api/devices/${deviceId}`, payload, { baseURL })
                .then((res) => res.data.data);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["account-device"] });
        },
    });
};
